import React, { useState } from "react";
import Map from "../Map/Map";
import AppBar from "../Map/AppBar";
import "../App.scss";
import Disclaimer from "../Map/Disclaimer/Disclaimer";
import About from "../Map/About/About";
import SiteLoader from "./SiteLoader";

const mobile = window.innerWidth < 601 ? true : false;

const MapView = () => {
    return (
        <div className="App">
            <Disclaimer />
            <SiteLoader />
            <About />
            <AppBar />
            <div className="map-content">
                <Map />
            </div>
        </div>
    );
};

export default MapView;
